import { dayjs } from './date-time';

const timezoneValidityCache = new Map<string, boolean>();

export const isValidTimezone = (timezone: string) => {
  if (!timezone) {
    return false;
  }

  const cached = timezoneValidityCache.get(timezone);
  if (cached !== undefined) {
    return cached;
  }

  let valid = false;
  try {
    valid = dayjs().tz(timezone).isValid();
  } catch {
    valid = false;
  }
  timezoneValidityCache.set(timezone, valid);
  return valid;
};
